import modals from "../helpers/modals";
import axios from "axios";

export default {
    bind(el, binding, vnode) {
        let $parts = binding.expression.split('.');
        let $name = $parts[$parts.length - 1];
        el.dataset.roll = $name;

        let $service = null;

        if ( el.dataset.hasOwnProperty('json')) {
            $service = el.dataset.json;
        }

        if (!modals.items.hasOwnProperty($name)) {
            modals.items[$name] = false;
        }
        vnode.context.$nextTick( function() {
            vnode.context.modals = modals.items;
        });

        let clickHandler =  ('ontouchstart' in document.documentElement ? "touchstart" : "click");

        if ( clickHandler === 'click' && el.dataset.hasOwnProperty('hover') === true ) {
            el.addEventListener('mouseenter', () => {
                modals.enter( $name , () => {
                    vnode.context.$nextTick( function() {
                        vnode.context.modals = modals.items;
                    });
                });
            }, { passive: true });
            el.addEventListener('mouseleave', () => {
                modals.leave(() => {
                    vnode.context.$nextTick( function() {
                        vnode.context.modals = modals.items;
                    });
                });
            }, { passive: true });
        }
        /**
         * This will handle the click/touch events
         */

        el.addEventListener(clickHandler, () => {
            if ( $service ) {
                axios.get($service).then((response) => {
                    modals.toggle( $name , (value) => {
                        vnode.context.service = {...vnode.context.service, ...response.data.data };
                        vnode.context.setPath(vnode.context, binding.expression, value );
                    });
                   // $self.actions = response.data.data.actions;
                }).catch(() => {

                });
            } else {
                modals.toggle( $name , (value) => {
                    vnode.context.setPath(vnode.context, binding.expression, value );
                });
            }
        });

        /**
         * This will handle the blur events
         */

        if ( el.dataset.hasOwnProperty('blur') === true ) {
            // Listen for Clicks and Taps
            document.body.addEventListener(clickHandler, (event) => {
                if ( modals.visible($name) === false ) {
                    return false;
                }
                let hide = true;
                let node = event.target;
                while (node) {
                    if (typeof node.attributes !== "undefined" && (node.getAttribute("data-drop") === $name || node.getAttribute('data-roll') === $name )) {
                        hide = false;
                        break;
                    }
                    if ( node.parentNode) {
                        node = node.parentNode;
                    } else {
                        break;
                    }
                }
                // We can hide if nothing has been found
                if (hide === true) {
                    modals.leave(() => {
                        vnode.context.$nextTick(function () {
                            vnode.context.modals = modals.items;
                        });
                    });
                }


            }, { passive: true } );
        }

    }
}